import clsx from "clsx";
import { FC, KeyboardEvent, MouseEvent } from "react";
import { useTranslation } from "react-i18next";

import { CourseIndicatorIcon, FramerTooltip } from "@ryde/controls";
import { ICoursesCalendarSlotDto, onActivateKeyDown } from "@ryde/shared";

import { buildCoursesCalendarCourseRouteTypeTooltip } from "./courses-calendar-cell.tooltip-utils";

interface ICoursesCalendarCellCourseRouteTypeTooltip {
  slot: ICoursesCalendarSlotDto;
  courseOpenClassName?: string;
  tooltipDisabled?: boolean;
  onOpenCourseClick: (e: MouseEvent | KeyboardEvent, courseId: number) => void;
}

export const CoursesCalendarCellCourseRouteTypeTooltip: FC<
  ICoursesCalendarCellCourseRouteTypeTooltip
> = ({ slot, courseOpenClassName, tooltipDisabled, onOpenCourseClick }) => {
  const { t } = useTranslation();
  const content = buildCoursesCalendarCourseRouteTypeTooltip({ t, slot });

  return (
    <FramerTooltip content={content} tooltipDisabled={tooltipDisabled}>
      <span
        className={clsx("cc-course-type-pill", courseOpenClassName)}
        onClick={e => onOpenCourseClick(e, slot.courseId)}
        onKeyDown={onActivateKeyDown(e => onOpenCourseClick(e, slot.courseId))}
        role="button"
        tabIndex={0}
        aria-label={slot.courseName}
      >
        <CourseIndicatorIcon routeType={slot.courseRouteType} />
      </span>
    </FramerTooltip>
  );
};
